export const environment = {
  idleTimeout: 3600000,
  production: false,
  apiUrl: "https://api-product-config.creconnects-feature.com",
  recaptchaSiteKey: '6Ld7gmMqAAAAAKR67YHtYbEvVSCi25V4CDH9jGs-',
  env: 'feature',
};
